import { Container, Grid, Typography, Paper } from '@mui/material';
import { useEffect, useState } from 'react';
import BlueButton from '../../components/blueButton';
import RedButton from '../../components/redButton';
import { Helmet } from 'react-helmet';
import globals from '../../globals';
import AccessibilityNewSharpIcon from '@mui/icons-material/AccessibilityNewSharp';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const getTimeLeft = () => {
    const targetDate = new Date('2026-05-17T23:59:59');
    const now = new Date();
    const difference = targetDate.getTime() - now.getTime();

    if (difference <= 0) return { isPast: true, days: 0, hours: 0, minutes: 0 };

    const totalMinutes = Math.floor(difference / (1000 * 60));
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    return { isPast: false, days, hours, minutes };
};

const CompetitionPage = () => {
    const [timeLeft, setTimeLeft] = useState(getTimeLeft());
    const [hasExistingParticipation, setHasExistingParticipation] = useState(false);
    const navigate = useNavigate();
    const { user, token } = useAuth();

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(getTimeLeft());
        }, 1000 * 60);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!token) {
            setHasExistingParticipation(false);
            return;
        }

        async function checkExistingParticipation() {
            try {
                const response = await fetch(`${globals.apiUrl}/competitions/participation`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!response.ok) {
                    setHasExistingParticipation(false);
                    return;
                }

                const data = await response.json();
                setHasExistingParticipation((data?.participations?.length || 0) > 0);
            } catch {
                setHasExistingParticipation(false);
            }
        }

        checkExistingParticipation();
    }, [token]);

    return (

        <Container maxWidth='lg'>
            {/* <Helmet>
                <title>Пробна матура по математика за 7 клас онлайн</title>
                <meta name="description" content="Онлайн пробна матура по математика за 7 клас по формата на НВО от eAcademiaBg . Провери нивото си, открий пропуските и се подготви ефективно за изпита." />
                <meta
                    property="og:title"
                    content="Пробна матура по математика за 7 клас онлайн"
                />
                <meta
                    property="og:description"
                    content="Онлайн пробна матура по математика за 7 клас по формата на НВО от eAcademiaBg. Провери нивото си, открий пропуските и се подготви ефективно за изпита."
                />
            </Helmet> */}
            <Grid container justifyContent={'center'} textAlign={'center'} spacing={2} direction={'column'}>
                <Grid item>
                    <img src="https://eacademiabg-test.s3.us-east-1.amazonaws.com/competitions.png" style={{ height: '25vw', width: 'auto' }} />
                </Grid>
                <Grid item>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 30, color: globals.colors.lightRed }}>Конкурс за стихотворение за 24 май
                        „Кажи го в стих“</Typography>
                </Grid>
                <Grid item>
                    <BlueButton text="Литературен конкурс" />
                </Grid>
            </Grid>
            <Paper sx={{ borderRadius: 2, mt: 5, py: 1, px: 5 }} elevation={4}>
                <Grid container justifyContent={'space-around'} textAlign={'center'} spacing={3}>
                    <Grid item>
                        <Typography sx={{ fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 17 }}>Крайна дата за участие:</Typography>
                        <Typography sx={{ fontWeight: 'bold', color: globals.colors.lightRed, fontSize: 20 }}>17.05.2026</Typography>
                    </Grid>
                </Grid>
            </Paper>

            <Paper sx={{ borderRadius: 2, mt: 5, py: 1, px: 2 }} elevation={4}>
                <Grid alignItems={'center'} textAlign={'center'}>
                    <Typography sx={{ fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 20 }}>
                        <AccessTimeFilledIcon sx={{ mb: -0.5, mr: 1, color: globals.colors.lightRed }} />Остават:
                    </Typography>
                </Grid>
                <Grid container justifyContent={'center'} textAlign={'center'} sx={{ mt: 1 }}>
                    <Grid item xs={2}>
                        <Typography sx={{ fontWeight: 'bold', color: globals.colors.lightRed, fontSize: 25 }}>{timeLeft.days}</Typography>
                        <Typography sx={{ fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 17 }}>Дни</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography sx={{ fontWeight: 'bold', color: globals.colors.lightRed, fontSize: 25 }}>{timeLeft.hours}</Typography>
                        <Typography sx={{ fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 17 }}>Часа</Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Typography sx={{ fontWeight: 'bold', color: globals.colors.lightRed, fontSize: 25 }}>{timeLeft.minutes}</Typography>
                        <Typography sx={{ fontWeight: 'bold', color: globals.colors.darkBlue, fontSize: 17 }}>Минути</Typography>
                    </Grid>
                </Grid>
                {timeLeft.isPast && (
                    <Grid textAlign={'center'} sx={{ mt: 1 }}>
                        <Typography sx={{ fontWeight: 'bold', color: globals.colors.lightRed }}>Крайният срок изтече.</Typography>
                    </Grid>
                )}
            </Paper>

            <Grid container justifyContent={'center'} textAlign={'center'} sx={{ mt: 5, mb:5 }}>
                <Grid item>
                    {/* <RedButton onClick={exam.is_purchased ? undefined : () => { if (!user) { navigate(`/login?redirect=/exams/${id}`); } else { handleClickOpen(); } }} disabled={exam.is_purchased} startIcon={<AddShoppingCartIcon />} pX={5} sx={{ fontWeight: 'bold', fontSize: 18 }} text={exam.is_purchased ? 'Вече закупен' : `Купи пробна матура €${exam.price}`} /> */}
                    <RedButton
                        text={hasExistingParticipation ? "Вече имаш заявено участие" : "Заяви участие"}
                        size={'large'}
                        pX={6}
                        sx={{ fontSize: 19, py: 1.2 }}
                        startIcon={<AccessibilityNewSharpIcon />}
                        disabled={hasExistingParticipation}
                        onClick={() => {
                            if (!user) {
                                navigate(`/login?redirect=${encodeURIComponent('/participation?redirect=/competition')}`);
                                return;
                            }
                            navigate('/participation?redirect=/competition');
                        }}
                    />
                    <Typography sx={{ fontSize: 13 }}>* Нужна е регистрация в сайта при участие </Typography>
                </Grid>
            </Grid >

            <Paper sx={{ borderRadius: 2, mt: 3, py: 1, px: 2 }} elevation={4}>
                <Grid id="what-is-the-competition" container justifyContent={'center'} alignItems={'center'}>
                    <Grid item textAlign={'center'}>
                        <Typography sx={{ fontSize: 19, color: globals.colors.lightRed, fontWeight: 'bold' }}>Какво представлява конкурсът?</Typography>
                    </Grid>
                    <Grid item xs={12} textAlign={'center'}>
                        <Typography
                            sx={{ fontSize: 16, mt: 1 }}
                            dangerouslySetInnerHTML={{
                                __html: `Конкурсът <strong>„Кажи го в стих“</strong> дава възможност на ученици от <strong>8.- 10. клас</strong>
                            да изразят своята любов към българската азбука, просвета и култура
                            чрез <strong>авторско стихотворение</strong>, посветено на <strong>24 май - Ден на българската просвета и култура и на славянската писменост.</strong>`,
                            }}
                        />
                    </Grid>
                </Grid>
            </Paper>

            <Paper sx={{ borderRadius: 2, mt: 5, py: 1, px: 2 }} elevation={4}>
                <Grid container id="how-to-participate" justifyContent={'space-around'} textAlign={'center'}>
                    <Grid item xs={12} sm={5}>
                        <Grid container justifyContent={'center'} textAlign={'left'}>
                            <Grid item>
                                <Typography sx={{ fontSize: 19, color: globals.colors.lightRed, fontWeight: 'bold' }}>Как да участваш?</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography
                                    component="div"
                                    dangerouslySetInnerHTML={{
                                        __html: `<ol>
                                    <li><strong>Последвай ни в Instagram - <a href='https://www.instagram.com/eacademiabg/' style="text-decoration: none; color: #e26965; font-weight: bold;">@eacademiabg</a></strong></li>
                                    <ul>
                                        <li>
                                            Следи профила ни, за да не изпускаш важна информация и обновления.
                                        </li>
                                    </ul>
                                    <li><strong>Харесай и сподели поста за конкурса.</strong></li>
                                    <ul>
                                        <li>
                                            Сподели го в своя Instagram story, за да помогнеш инициативата да достигне до повече ученици.
                                        </li>
                                    </ul>
                                    <li><strong>Регистрирай се на сайта.</strong></li>
                                    <ul>
                                        <li>
                                            За да запишеш своето участие официално.
                                        </li>
                                    </ul>
                                    <li><strong>Изпрати своето стихотворение.</strong></li>
                                    <ul>
                                        <li>
                                            Създай авторско стихотворение, посветено на 24 май,
                                            и го прикачи чрез формата за участие.
                                        </li>
                                    </ul>
                                </ol>`,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <img src='https://eacademiabg-test.s3.us-east-1.amazonaws.com/how+to.png' style={{ height: 250, width: 'auto', marginTop: 5 }} />
                    </Grid>
                </Grid>
            </Paper>

            <Paper sx={{ borderRadius: 2, mt: 3, py: 1, px: 2 }} elevation={4}>
                <Grid id="what-is-the-competition" container justifyContent={'center'} alignItems={'center'}>
                    <Grid item textAlign={'center'}>
                        <Typography sx={{ fontSize: 19, color: globals.colors.lightRed, fontWeight: 'bold' }}>Оценяване, избор на победител и награда</Typography>
                    </Grid>
                    <Grid item xs={12} textAlign={'center'}>
                        <Typography sx={{ fontSize: 16, mt: 1 }} dangerouslySetInnerHTML={{__html:`Екипът на eAcademiaBg ще подбере трите най-добри стихотворения.
                            Те ще бъдат публикувани в Instagram профила на eAcademiaBg (<a href='https://www.instagram.com/eacademiabg/' style="text-decoration: none; color: #e26965; font-weight: bold;" >@eacademiabg</a>) на <strong>19.05.2026</strong>, където аудиторията ще може да гласува чрез харесване и споделяне на story до <strong>24.05.2026 вкл. </strong>
                            На <strong>25.05.2026</strong> произведението с най-много харесвания и споделяния ще бъде официално обявено за победител.
                            Победителят ще получи парична награда от <strong>50€ и грамота</strong>.`}}>
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>

            <Grid container spacing={3} alignItems={'center'}>
                <Grid item xs={12}>
                    <Paper sx={{ borderRadius: 2, mt: 5, py: 1, px: 2 }} elevation={4}>
                        <Grid container>
                            <Grid item xs={12} sm={12} textAlign={'center'}>
                                <Typography sx={{ fontSize: 19, color: globals.colors.lightRed, fontWeight: 'bold' }}>Условия за участие</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography
                                    component="div"
                                    dangerouslySetInnerHTML={{
                                        __html: `<ol>
                                    <li>В конкурса могат да участват ученици от <strong>8. - 10. клас.</strong></li>
                                    <li>Всеки участник може да изпрати <strong>само едно авторско стихотворение.</strong></li>
                                    <li>Творбите трябва да бъдат на <strong>български език и посветени на 24 май</strong> - Ден на българската просвета и култура и на славянската писменост.</li>
                                    <li>Допустимият обем на творбата е между <strong>100 и 200 думи.</strong></li>
                                    <li>Текстовете трябва да бъдат <strong>оригинални и създадени лично от участника.</strong></li>
                                    <li><strong>Не се допуска използването на изкуствен интелект (AI) при създаването на стихотворенията!</strong></li>
                                    <li><strong>Организаторите си запазват правото да не допускат творби, които не отговарят на условията или съдържат плагиатство.</strong></li>
                                    <li>С участието си в конкурса <strong>участникът се съгласява творбата му да бъде използвана за целите на инициативата</strong> (публикации, представяне на победители и др.).</li>
                                </ol>`,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </Container >
    );
}

export default CompetitionPage